var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 0.25C27.4423 0.25 28.7728 1.01172 29.5041 2.26094L51.4416 39.6359C52.183 40.8953 52.183 42.4492 51.4619 43.7086C50.7408 44.968 49.39 45.75 47.9377 45.75H4.06266C2.61031 45.75 1.25953 44.968 0.538439 43.7086C-0.182655 42.4492 -0.172499 40.8852 0.558751 39.6359L22.4963 2.26094C23.2275 1.01172 24.558 0.25 26.0002 0.25ZM26.0002 13.25C24.6494 13.25 23.5627 14.3367 23.5627 15.6875V27.0625C23.5627 28.4133 24.6494 29.5 26.0002 29.5C27.3509 29.5 28.4377 28.4133 28.4377 27.0625V15.6875C28.4377 14.3367 27.3509 13.25 26.0002 13.25ZM29.2502 36C29.2502 34.2023 27.7978 32.75 26.0002 32.75C24.2025 32.75 22.7502 34.2023 22.7502 36C22.7502 37.7977 24.2025 39.25 26.0002 39.25C27.7978 39.25 29.2502 37.7977 29.2502 36Z",
    fill: "#ED5B5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/red-warning.cc71a031.svg";
export { ForwardRef as ReactComponent };